import { DataGridSettings } from '../../../../interfaces/DataGrid/DataGridSettings'

export const dataGridViewerSettings: DataGridSettings = {
  spacing: 0,
  sortingMode: 'single',
  columns: [
    {
      title: 'SKU/EAN',
      dataField: 'sku',
      xs: 12,
      sm: 6,
      lg: 4,
      allowSorting: false
    },

    {
      title: 'Nombre',
      dataField: 'name',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },

    {
      title: 'Cantidad',
      dataField: 'realQty',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'FillRate',
      dataField: 'fillrate',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    }
  ]
}
